import { Component, Input, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { User } from 'src/app/interfaces/user';
import { AuthService } from 'src/app/services/auth.service';
import { CartService } from 'src/app/services/cart.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-header-desktop',
  templateUrl: './header-desktop.component.html',
  styleUrls: ['./header-desktop.component.scss'],
})
export class HeaderDesktopComponent implements OnInit {
  @Input() customSearchbar: boolean;
  notificationCount: number;
  cartCount: number;
  user: User;
  display_name: string;
  isAuthenticated: boolean;

  constructor(
    private notificationService: NotificationService,
    private cartService: CartService,
    private authService: AuthService,
  ) {}

  async ngOnInit() {
    this.isAuthenticated = await this.authService.isAuthenticated();

    if (!this.isAuthenticated) {
      return;
    }

    this.getData();
    this.cartService.cartCount$.subscribe(count => {
      this.cartCount = count;
    });
  }

  getData() {
    const notificationReq = this.notificationService.getNotifications();
    const cartCountReq = this.cartService.getCartCount();
    const userReq = this.authService.getProfile();

    forkJoin([notificationReq, cartCountReq, userReq]).subscribe({
      next: ([notificationRes, cartCountRes, userRes]) => {
        this.notificationCount = notificationRes.meta.ack_zero_count || 0;
        this.cartService.setCartCount(cartCountRes.count);
        this.user = userRes.user;
        this.getDisplayName();
      },
    });
  }

  getFirstName(name: string) {
    return name.split(' ')[0];
  }

  getDisplayName() {
    if (!this.user) {
      this.display_name = 'user';
      return;
    }

    const displayName = this.user?.name
      ? this.getFirstName(this.user?.name)
      : this.user?.username
      ? this.user?.username
      : 'user';

    this.display_name = displayName;
  }
}
